export default {
  getOrders(state) {
    return state.orders;
  },
};
